var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.05714C9.32107 8.05714 11 6.3782 11 4.30713C11 2.23606 9.32107 0.557129 7.25 0.557129C5.17893 0.557129 3.5 2.23606 3.5 4.30713C3.5 6.3782 5.17893 8.05714 7.25 8.05714Z",
    stroke: "#674BF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.5571V16.8071C1 15.481 1.52678 14.2093 2.46446 13.2716C3.40215 12.3339 4.67392 11.8071 6 11.8071H8.50001C9.82609 11.8071 11.0979 12.3339 12.0355 13.2716C12.9732 14.2093 13.5 15.481 13.5 16.8071V18.0571",
    stroke: "#674BF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.05713C18.6307 8.05713 19.75 6.93784 19.75 5.55713C19.75 4.17642 18.6307 3.05713 17.25 3.05713C15.8693 3.05713 14.75 4.17642 14.75 5.55713C14.75 6.93784 15.8693 8.05713 17.25 8.05713Z",
    stroke: "#674BF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.8071V14.3071C13.5 13.6441 13.7634 13.0082 14.2323 12.5393C14.7011 12.0705 15.337 11.8071 16 11.8071H18.5C19.163 11.8071 19.799 12.0705 20.2678 12.5393C20.7367 13.0082 21 13.6441 21 14.3071V15.5571",
    stroke: "#674BF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairStatus);
export default __webpack_public_path__ + "static/media/pair-status.9fcf9ac0370866c1b1c5f55b9c4cda1c.svg";
export { ForwardRef as ReactComponent };